<template>
  <td  style="padding: 0 !important;">
    <div class="inCellHeight" v-if="trend !== undefined && trend !== null" :class="setColor()">
      <i :class="setIcon()"/>
    </div>
    <div class="inCellHeight" v-else>
      -
    </div>
  </td>
</template>

<script>
export default {
  name: "TrendIconCell",
  props: ['trend'],
  methods: {
    setIcon() {

      return this.trend === 1 ? 'ri-arrow-right-up-line' : this.trend === -1 ? 'ri-arrow-right-down-line' : 'ri-pulse-line';
    },
    setColor() {
      return this.trend === 1 ? 'green' : this.trend === -1 ? 'red' : 'neutral';
    }
  }
}
</script>

<style scoped lang="scss">
td {
  padding: 0 !important;
}

div {
  padding: 7.5px 10px !important;
}
</style>
